/* eslint react/jsx-key: off */
import React from "react";
import PropTypes from "prop-types";
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  required,
  BooleanInput
} from "react-admin";
import { EditActions, EditToolbar } from "../utilities/EditView";
import Title from "../Title";

const UserEdit = ({ permissions, ...props }) => (
  <Edit
    { ...props }
    actions={ <EditActions NoShowButton /> }
    title={ <Title type="User" /> }
  >
    <TabbedForm toolbar={ <EditToolbar /> }>

      <FormTab label="Summary" >
        <TextInput
          source="Authentication.username"
          label="User Name"
          validate={ required() }
        />
        <TextInput source="name" label="First Name" />
        <TextInput source="last_name" label="Last Name" />
        <TextInput source="email" label="Email" validate={ required() } />
        <TextInput source="phone" label="Phone" />
      </FormTab>

      <FormTab label="Web APP Permissions" >
        <BooleanInput source="Authentication.Permission.web_app_user" label="Users" validate={ required() } />
        <BooleanInput source="Authentication.Permission.web_app_traderev_auto_proxy" label="TradeRev Auto Proxy" validate={ required() } />
      </FormTab>
    </TabbedForm>
  </Edit>
);

// UserEdit.propTypes = {
//   id: PropTypes.any.isRequired,
//   location: PropTypes.object.isRequired,
//   match: PropTypes.object.isRequired,
//   permissions: PropTypes.string
// };

export default UserEdit;
